import { gamesUrl } from './config';

/**
 * The preview iframes read their host from `window.__GAMES_DEV_URL__` (falling back to production)
 * when their modules load. Set here, before any of them is imported, it points them at this
 * build's environment. A value set before the app loads — a local games dev server — is kept.
 */
const w = window as unknown as { __GAMES_DEV_URL__?: string };
if (!w.__GAMES_DEV_URL__) {
    w.__GAMES_DEV_URL__ = gamesUrl;
}
